import { Observable } from 'rxjs';

/** Convert a Blob to a base64 string (no data-url prefix) */
export function blobToBase64(blob: Blob): Observable<string> {
    return new Observable<string>((observer) => {
        const reader = new FileReader();
        reader.onloadend = () => {
            const dataUrl = reader.result as string;
            const base64 = dataUrl.split(',')[1];
            observer.next(base64);
            observer.complete();
        };
        reader.onerror = (error) => observer.error(error);
        reader.readAsDataURL(blob);
    });
}
